import{optimizedAppearDataAttribute as r}from"./data-id.mjs.js";function o(o){return o.props[r]}export{o as getOptimisedAppearId};
